// src/app/slices/drainPanSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AccessoryState, IDrainPan, IDrainPanParams } from '../models';
import { deleteAccessory } from './actions';

const initialState: AccessoryState<IDrainPan, IDrainPanParams> = {
  accessories: {},
  params: null,
};

const drainPanSlice = createSlice({
  name: 'drain_pan',
  initialState,
  reducers: {
    setDrainPan: (state, action: PayloadAction<IDrainPan>) => {
      if (!state.accessories[action.payload.section_id])
        state.accessories[action.payload.section_id] = {};
      state.accessories[action.payload.section_id][action.payload.id] =
        action.payload;
    },
    setDrainPanParams: (state, action: PayloadAction<IDrainPanParams>) => {
      state.params = action.payload;
    },
    deleteDrainPan: deleteAccessory,
  },
});

export const { setDrainPan, setDrainPanParams, deleteDrainPan } =
  drainPanSlice.actions;

export default drainPanSlice.reducer;
